import { render, staticRenderFns } from "./intro-story.vue?vue&type=template&id=5dc45f6a&scoped=true&"
import script from "./intro-story.vue?vue&type=script&lang=js&"
export * from "./intro-story.vue?vue&type=script&lang=js&"
import style0 from "./intro-story.vue?vue&type=style&index=0&id=5dc45f6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc45f6a",
  null
  
)

export default component.exports